exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.error-message-div[data-v-8eff8bc8] {\n  position: fixed;\n  /* width: 210px; */\n  top: 6%;\n  right: 3%;\n  z-index: 10000;\n  border: 1px solid #a5271f;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  background: #ffffff;\n}\n.error-bg[data-v-8eff8bc8] {\n  padding: 16px;\n  background: rgba(212, 91, 84, 0.1);\n}\n.msg-content[data-v-8eff8bc8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  max-width: 374px;\n}\n.error-msg[data-v-8eff8bc8] {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 130%;\n  color: #a5271f;\n  padding-top: 2px;\n}\n", ""]);

// exports
